const APIS = {
  FILE: "/driveservice/api/file/",
  FOLDER: "/driveservice/api/folder/",
  SEARCH: "/driveservice/api/search/",
  QR_UPLOAD: "/driveservice/api/qr-upload/",
  GENERATE_QR: "/driveservice/api/generate-qr/",
};
export default APIS;
